import { Icon, type IconName } from "@uigovpe/components";

const notifications = [
  {
    id: "1",
    type: "Curso",
    icon: "school" as IconName,
    title: "Fotografia para pequenos negócios",
    description:
      "Aprenda a destacar seus produtos e serviços com fotos incríveis.",
  },
  {
    id: "2",
    type: "Evento",
    icon: "badge" as IconName,
    title: "Negócios digitais",
    description:
      "Orientações práticas sobre divulgação, presença digital e oportunidades.",
  },
];

const tips: Array<{ icon: IconName; text: string }> = [
  {
    icon: "person",
    text: "Complete seu perfil com foto e descrição atualizada",
  },
  {
    icon: "photo_camera",
    text: "Adicione fotos de qualidade aos seus produtos",
  },
  {
    icon: "share",
    text: "Compartilhe o link da sua vitrine nas redes sociais",
  },
];

export default function NotificationsSecretariat() {
  return (
    <section className="mt-12! mb-8! grid min-w-0 gap-4 lg:grid-cols-[minmax(0,1.5fr)_minmax(320px,440px)]">
      <div className="flex min-w-0 flex-col rounded-2xl bg-[#f8fafc]! p-6! shadow-md">
        <div className="mb-6! flex items-center gap-3">
          <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-[#4e3873]!">
            <Icon icon="campaign" outline className="text-white!" />
          </span>
          <h2 className="text-lg! font-bold! text-[#494c57]!">
            Notificações da Secretaria da Mulher
          </h2>
        </div>
        <div className="grid flex-1 gap-4 md:grid-cols-2">
          {notifications.map((item) => (
            <article
              key={item.id}
              className="flex min-w-0 gap-3 rounded-xl p-3! transition-colors hover:bg-gray-50!"
            >
              <span className="flex h-[72px] w-[88px] shrink-0 items-center justify-center rounded-lg bg-[#d4cef7]!">
                <Icon
                  icon={item.icon}
                  outline
                  size="large"
                  className="text-[#4e3873]!"
                />
              </span>
              <div className="min-w-0 flex-1">
                <span className="inline-flex items-center gap-1 rounded-2xl bg-[#f6f2fc]! px-2! py-1! text-xs! font-medium! text-[#4e3873]!">
                  <Icon icon={item.icon} outline size="small" />
                  {item.type}
                </span>
                <h3 className="mt-1! truncate text-sm! font-bold! text-[#494c57]!">
                  {item.title}
                </h3>
                <p className="line-clamp-2 text-xs! leading-[1.5]! text-[#424b5a]!">
                  {item.description}
                </p>
              </div>
            </article>
          ))}
        </div>
        <a
          href="#notificacoes"
          className="mt-4! flex items-center gap-1 text-sm! font-medium! text-[#4e3873]! no-underline!"
        >
          Ver mais informações <Icon icon="arrow_right_alt" outline />
        </a>
      </div>

      <div className="flex min-w-0 flex-col rounded-2xl bg-[#f6f2fc]! p-6! shadow-md">
        <div className="mb-6! flex items-center gap-3">
          <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-[#4e3873]!">
            <Icon icon="lightbulb" outline className="text-white!" />
          </span>
          <h3 className="font-bold! text-[#494c57]!">
            Dicas para ter mais visibilidade
          </h3>
        </div>
        <div className="flex flex-1 flex-col gap-4">
          {tips.map((tip) => (
            <div key={tip.text} className="flex items-center gap-3">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[#d4cef7]!">
                <Icon icon={tip.icon} outline className="text-[#4e3873]!" />
              </span>
              <p className="text-sm! text-[#424b5a]!">{tip.text}</p>
            </div>
          ))}
        </div>
        <a
          href="#dicas"
          className="mt-6! flex items-center gap-1 text-sm! font-medium! text-[#4e3873]! no-underline!"
        >
          Ver detalhes <Icon icon="arrow_right_alt" outline />
        </a>
      </div>
    </section>
  );
}
